import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { ParsedDate, parseIsoDate } from '../../types';

interface DispatchEventRawFields {
  id: number;
  legId: number;
  date?: string | null;
  type: string;
  usrId: string;
  usrName: string;
  note: string;
}

export type DispatchEvent = GridValidRowModel & {
  id: number;
  legId: number;
  eventDate?: ParsedDate;
  eventType: string;
  userId: string;
  userName: string;
  note: string;
};

export function transformDispatchEventResponse(result: DispatchEventRawFields[]): DispatchEvent[] {
  return sortDispatchEvents(
    result.map((item) => {
      return {
        id: item.id,
        legId: item.legId,
        eventDate: parseIsoDate(item.date),
        eventType: item.type,
        userId: item.usrId,
        userName: item.usrName,
        note: item.note
      };
    })
  );
}

/** Method for sorting the Leg Events for the leg event grid */
export function sortDispatchEvents(dispatchEvents: DispatchEvent[]) {
  return dispatchEvents.sort((a, b) => {
    // sort by Event Date descending
    const aEventDt = a.eventDate?.unix;
    const bEventDt = b.eventDate?.unix;

    if (aEventDt !== bEventDt) {
      /** Nulls go last */
      if (!aEventDt) {
        return -1;
      }
      if (!bEventDt) {
        return 1;
      }

      if (aEventDt > bEventDt) {
        return -1;
      } else if (aEventDt < bEventDt) {
        return 1;
      }
    }
    return 0;
  });
}
